import { POST } from "@/utils/axios";

//首页banner轮播图片数据
export function getIndexBannerList(){
    return POST('/common/getIndexImageList', {})
}

//首页引流标题数据
export function getTitleDataList(){
    return POST('/common/getIndexTitleList', {})
}

//首页教师图片数据
export function getTeacherInfoList(){
    return POST('/common/getTeacherInfoList', {})
}

export function apiGetIndexVideoList(){
    return POST('/common/getIndexVideoList', {})
}

export function apiGetIndexVideoPlayUrl(data){
    return POST('/common/generateIndexVideoPlayUrl', data)
}